module.exports = __webpack_public_path__ + "img/auth-阿虎医考-授权书铜牌.cf2d8a4b.png";